import routeReducer from './routeSlice';
import * as routeActions from './actions';
import * as routeSelector from './selector';

export {
  routeActions,
  routeSelector
}

export default routeReducer